import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'

export function NotFound404 () {
  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Common.PageNotFoundTitle' />
        </MainTopTitle>
      </MainTop>

      <MainBody transparent>
        <div><Resx name='Common.PageNotFoundContent' /></div>
      </MainBody>
    </Main>
  )
}



// WEBPACK FOOTER //
// ./src/components/404.js